import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $on = _ref.$on,
      $update = _ref.$update;
  var qrcode,
      usercode,
      usr = {
    data: {}
  },
      isCordovaIOS = $f7.device.cordova && $f7.device.ios;
  var qrcode_message = isCordovaIOS ? lng.qrcode_message_ios : lng.qrcode_message;
  $on('pageInit', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var qrcodekey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!myApp.children) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return myApp.getChildren();

          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 6:
            _context.next = 8;
            return myApp.user();

          case 8:
            _context.t0 = _context.sent;

          case 9:
            usr = _context.t0;
            usr = usr || {
              data: {}
            };
            usercode = Number(usr.username.replace(/[^0-9]/g, '') * 1).toString(16);

            if (myApp.children) {
              usercode += 'Z' + myApp.children;
            }

            qrcodekey = myApp.children ? 'qrcode_' + myApp.children : 'qrcode';
            _context.next = 16;
            return myStorage.get(qrcodekey);

          case 16:
            qrcode = _context.sent;

            if (qrcode) {
              _context.next = 21;
              break;
            }

            _context.next = 20;
            return myApp.server.getQrcode();

          case 20:
            qrcode = _context.sent;

          case 21:
            $update();

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="qrcode">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">
          <div class="display-flex align-items-center">
            <div class="avatar-small margin-left-half" style="background-image: url(${usr.data.avatar})"></div>
            <div class="padding-left">${usr.data.name}</div>
          </div>
        </div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll qrcode-container unselectable">

      <img class="logo" src="static/logo.png" alt=""/>

      ${qrcode && $h`
      <div class="qrcode">
        
        <img src="${qrcode}" alt=""/>
      
        ${usercode ? $h`
        <h3 class='text-align-center'>
          <small class='text-align-center'>${lng.unique_personal_code}:</small><br/><span  class='text-upper text-align-center'>${usercode}</span> 
        </h3>
        ` : '' }
      </div>
      <div class="qrcode-caption">
        ${usercode ? $h` ${qrcode_message} <strong>www.doctorpass.it</strong> ${lng.qrcode_message_2}. ` : lng.qrcode_message_1}
      </div>
      `}

      <div class="my-footer padding-bottom">
        <hr class="sep"/>
        <a href="http://www.processfarm.net" class="link external text-color-black" target="_system">
          <span>Prodotto da <img class="process-services" src="static/process-services.png"/> srl Società Benefit 
            <br/> 01549880050 - www.processfarm.net</span>
        </a>
      </div>

    </div>
  </div>
`
    }
    ;
});